import { gql } from '@apollo/client';

import type { Session, UserData } from '@cobliteam/common-types';

import type { AccessibleFleetAPI, UserAttributesAPI, UserPreferencesAPI } from '../../account';
import { accessibleFleetsApiToAccessibeFleets, userAttributesTransformer, userPreferencesTransformer } from '../../account/user/UserTransformer';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLUserRequester {
  private queryGetUserData = gql`
    query getUserData($input: UserInput) {
      hasCameraFlag
      hasRedeCan
      userPreferences(input: $input) {
        id
        fleet_id
        user_id
        vehicle_group_ids
        use_vehicles_cluster
        updated_at
        created_at
      }
      userAttributes(input: $input) {
        creation_date
        num_devices
      }
      userFleets(input: $input) {
        id
        name
        active
        managers
        user_id
        fleet_id
        role
        groups_restriction
        associated_at
        granted_permissions
        has_no_valid_groups
        has_only_groups_with_no_vehicles
      }
    }
  `;

  public getUserData = async ({ session }: { session: Session }) => {
    // Os resolvers do janus chamam os backends via bouncer com o JWT do usuário; numa sessão de
    // frota inativa (sem basic:permission) eles falham um a um e os campos chegam null
    // (errorPolicy 'all'). O boot não pode depender deles — todo campo tem default seguro.
    const response: {
      hasCameraFlag: boolean | null;
      hasRedeCan: boolean | null;
      userPreferences?: UserPreferencesAPI | null;
      userAttributes: UserAttributesAPI | null;
      userFleets: AccessibleFleetAPI[] | null;
    } = await graphQLRequester.query({
      query: this.queryGetUserData,
      variables: {
        input: {
          userId: session.user.id,
        },
      },
    });

    // Sem lista do backend (cobler não tem associações; resolver falhou na sessão inativa),
    // a frota da sessão é o fallback são.
    const userFleets = response.userFleets ? accessibleFleetsApiToAccessibeFleets(response.userFleets) : [session.fleet];

    // transform data
    const userData: UserData = {
      hasCameraFlag: Boolean(response.hasCameraFlag),
      hasRedeCan: Boolean(response.hasRedeCan),
      userPreferences: userPreferencesTransformer(response.userPreferences),
      userAttributes: userAttributesTransformer(response.userAttributes),
      userFleets,
    };

    return userData;
  };
}

export default GraphQLUserRequester;
